// Fail closed: an unset or misconfigured build env must never let a visitor-supplied
// evaluation_date pin the promo window, so only an explicit non-production value opens it.
export function allowsEvaluationDateOverride(): boolean {
	const env = process.env.NEXT_PUBLIC_CALM_ENV;
	return !!env && env !== 'production';
}
